<template>
<div class="main-bg n2">
    <div class="map-page">

      <div class="map" style="position: inherit;">

      <!-- Background Image -->
      <img data-v-2c415e29="" src="/assets/images/N2TopWinter.svg" alt="Monkeys enjoying a hot spring" class="n2-top-img">  

      <!-- Japanese Lessons: Choose One-->
      <div class="main-text">
        <div class="japanese-lessons">Japanese <br> Lessons</div>
        <div class="choose-one">Choose one</div>
      </div>  

      <!-- Progress Circle -->
      <progressbar v-if="Level && (Progress!=null)" :level="Level" :progress="Progress" :sectionlist="sectionList"></progressbar> 

      <!-- Units -->
      <div class="units-n2-container">
        <div class="units-n2">

          <a class="units-n2-link" @click.prevent="selectSection('unit1')" :class="{ 'hidden' : !ifTrueUnit('unit1') }">
            <div class="units-n2-unit">
              <div class="unit-number">1</div>
              <div class="unit-text">Unit</div>
            </div>
          </a> 

          <a class="units-n2-link" @click.prevent="selectSection('unit2')" :class="{ 'hidden' : !ifTrueUnit('unit2') }">
            <div class="units-n2-unit">
              <div class="unit-number">2</div>
              <div class="unit-text">Unit</div>
            </div>
          </a> 

          <a class="units-n2-link" @click.prevent="selectSection('unit3')" :class="{ 'hidden' : !ifTrueUnit('unit3') }">
            <div class="units-n2-unit">
              <div class="unit-number">3</div>
              <div class="unit-text">Unit</div>
            </div>
          </a> 

          <a class="units-n2-link" @click.prevent="selectSection('unit4')" :class="{ 'hidden' : !ifTrueUnit('unit4') }">
            <div class="units-n2-unit">
              <div class="unit-number">4</div>
              <div class="unit-text">Unit</div>
            </div>
          </a> 

           <a class="units-n2-link" @click.prevent="selectSection('unit5')" :class="{ 'hidden' : !ifTrueUnit('unit5') }">
            <div class="units-n2-unit">
              <div class="unit-number">5</div>
              <div class="unit-text">Unit</div>
            </div>
          </a> 

          <a class="units-n2-link" @click.prevent="selectSection('unit6')" :class="{ 'hidden' : !ifTrueUnit('unit6') }">
            <div class="units-n2-unit">
              <div class="unit-number">6</div>
              <div class="unit-text">Unit</div>
            </div>
          </a> 

          <a class="units-n2-link" @click.prevent="selectSection('unit7')" :class="{ 'hidden' : !ifTrueUnit('unit7') }">
            <div class="units-n2-unit">
              <div class="unit-number">7</div>
              <div class="unit-text">Unit</div>
            </div>
          </a> 

          <a class="units-n2-link" @click.prevent="selectSection('unit8')" :class="{ 'hidden' : !ifTrueUnit('unit8') }">
            <div class="units-n2-unit">
              <div class="unit-number">8</div>
              <div class="unit-text">Unit</div>
            </div>
          </a> 

          <a class="units-n2-link" @click.prevent="selectSection('unit9')" :class="{ 'hidden' : !ifTrueUnit('unit9') }">
            <div class="units-n2-unit">
              <div class="unit-number">9</div>
              <div class="unit-text">Unit</div>
            </div>
          </a> 

          <a class="units-n2-link" @click.prevent="selectSection('unit10')" :class="{ 'hidden' : !ifTrueUnit('unit10') }">
            <div class="units-n2-unit">
              <div class="unit-number">10</div>
              <div class="unit-text">Unit</div>
            </div>
          </a> 

          <a class="units-n2-link" @click.prevent="selectSection('unit11')" :class="{ 'hidden' : !ifTrueUnit('unit11') }">
            <div class="units-n2-unit">
              <div class="unit-number">11</div>
              <div class="unit-text">Unit</div>
            </div>
          </a> 

          <a class="units-n2-link" @click.prevent="selectSection('unit12')" :class="{ 'hidden' : !ifTrueUnit('unit12') }">
            <div class="units-n2-unit">
              <div class="unit-number">12</div>
              <div class="unit-text">Unit</div>
            </div>
          </a> 

           <a class="units-n2-link" @click.prevent="selectSection('unit13')" :class="{ 'hidden' : !ifTrueUnit('unit13') }">
            <div class="units-n2-unit">
              <div class="unit-number">13</div>
              <div class="unit-text">Unit</div>
            </div>
          </a> 

          <a class="units-n2-link" @click.prevent="selectSection('unit14')" :class="{ 'hidden' : !ifTrueUnit('unit14') }">
            <div class="units-n2-unit">
              <div class="unit-number">14</div>
              <div class="unit-text">Unit</div>
            </div>
          </a> 

          <a class="units-n2-link" @click.prevent="selectSection('unit15')" :class="{ 'hidden' : !ifTrueUnit('unit15') }">
            <div class="units-n2-unit">
              <div class="unit-number">15</div>
              <div class="unit-text">Unit</div>
            </div>
          </a> 

        </div>
      </div>  
      <!--/・Units -->

      </div>
    </div>
</div>  
</template>

<script>
import { api, appEnv, useCoachmark } from "../../config";
import { mapState } from "vuex";
import status from '../../mixins/status';

import ProgressBar from '../shared/ProgressBar.vue'

import Driver from 'driver.js';
import 'driver.js/dist/driver.min.css';

export default {
  mixins: [
    status
  ],
  components: {
    'progressbar': ProgressBar,
  },
  data() {
    return {
      step: 'top',
      authUser: null,
      ifSection: {},
      driver: null,
      storage: {}
    }
  },
  computed: {
    ...mapState({
      user: (state) => state.auth,
    }),
    Level() {
      return "N2"
    },
    sectionData() {
      return this.$store.getters.section_data;
    },
    Progress() {
      return this.$store.getters.progress;
    },
    sectionList() {
      return this.$store.getters.section;
    },
    ifTrueUnit: function() {
      let self = this
      return function(unit) {
        return unit in self.ifSection ? self.ifSection[unit] : false
      }
    },
    ifTrueTohoku() {
      return this.ifTohoku
    },
    ifTrueKanto() {
      return this.ifKanto
    },
    ifTrueChubu() {
      return this.ifChubu
    },
    ifTrueKansai() {
      return this.ifKansai
    },
    ifTrueShikoku() {
      return this.ifShikoku
    },
    ifTrueChugoku() {
      return this.ifChugoku
    },
    ifTrueKyushu() {
      return this.ifKyushu
    },
    ifTrueOkinawa() {
      return this.ifOkinawa
    }
  },

  created() {
  },

  mounted() {
    
    let self = this;
    self.$store.dispatch("showLoading", true);

    
    axios.get(api.section + '?level=n2')
    .then(function(resp) {
      self.$store.dispatch("setSection", resp.data.section);
      console.log('setSection')

      let section_list = self.$store.getters.section
      for (let section in section_list) {
        if(section == "unit1") {
          if (section_list[section].status == 'start'
            || section_list[section].status == 'completed') {
            self.ifSection[section] = true
          }
        } else {
          if ( section_list[section].status == 'ready'
            || section_list[section].status == 'start'
            || section_list[section].status == 'completed') {
            self.ifSection[section] = true
          }
        }
      }
      
      self.getProgress();
      
      self.$store.dispatch("showLoading", false);
      
      if(useCoachmark) {
        self.storage = (appEnv === 'production') ? window.localStorage : window.sessionStorage
        
        const isCoachmarkDone = self.storage.getItem("coachmarkdone") ? JSON.parse(self.storage.getItem("coachmarkdone")) : null;
        if(!(isCoachmarkDone && self.step in isCoachmarkDone && isCoachmarkDone[self.step])) {
          self.showCoachMark();
        }
      }
    })
    .catch(err => {
      self.$store.dispatch("showLoading", false);
    });
  },
  methods: {
    getProgress() {
      // 現在のレベル
      // Get progress on condition of level
      axios.get(api.progress, {
        params: {
          level: this.Level,
        }
      })
      .then((resp) => {
        this.$store.dispatch('setProgress', resp.data.progress_rate)
        console.log('setProgress')

        // 3. If the progress is 100%, check the status of the section and update the level
        if (resp.data.progress_rate > 0 && resp.data.progress_rate %100 == 0) {
          
          if(this.$store.getters.level == 'N5' || this.$store.getters.level == 'N4') {
          
            axios.post(api.updateUserLevel, {
              level: this.$store.getters.level,
            })
            .then((resp) => {
              if (resp.data) {
                this.$store.dispatch('setLevel',  resp.data.level)
                this.$store.dispatch('setProgress', 0)
              }
            });
          }
        }
      });
      
    },
    
    selectSection(section_name) {
      
      if(this.driver) {
        this.driver.reset();
      } else {
        this.initCoachMark();
      }
      if(!(section_name in this.$store.getters.section)) {
        return false
      }
      this.$store.dispatch("setSectionData", this.$store.getters.section[section_name]);
      this.$store.dispatch("setSectionStatus", this.$store.getters.section[section_name].status);

      // Update status the first time
      if (this.$store.getters.section_status == "ready") {
        this.statusSection('start');
      }

      this.$router.push({ name: 'region', params: {region: section_name} });
    },
    initCoachMark() {
      if(this.driver) {
        this.driver.reset()
      } else {
        const driverOverlay = document.getElementById('driver-page-overlay')
        const driverStage = document.getElementById('driver-highlighted-element-stage')
        const driverItem = document.getElementById('driver-popover-item')
        const driverItem2 = document.getElementById('driver-popover-item2')
        
        if(driverOverlay) {
          driverOverlay.remove()
        }
        if(driverStage) {
          driverStage.remove()
        }
        if(driverItem) {
          driverItem.remove()
        }
      }
    },
    showCoachMark() {
      let self = this
      if(!this.authUser) return false;
      
       this.driver = new Driver({
          className: "scoped-class-dark",
          animate: true,
          opacity: 0.7,
          padding: 10,
          stageBackground: 'rgba(255, 255, 255, 0.5)',
          allowClose: true,
          overlayClickNext: false,
          DoneBtnText: "Done",
          CloseBtnText: "Close",
          NextBtnText: "Next",
          PrevBtnText: "Previous step",
          onReset: (e) => {
          
            let coachMarks = JSON.parse(this.storage.getItem("coachmarkdone")|| null);
            if(!coachMarks) {
              coachMarks = {};
              coachMarks[this.step] = true;
            } else {
              coachMarks[this.step] = true;
            }

            this.storage.setItem("coachmarkdone", JSON.stringify(coachMarks));
          }
      });
      setTimeout(() => {
        this.driver.highlight({
          element: '.map-click-1',
          popover: {
            className: 'popover-class',
            title: 'click to Start Lesson',
            position: 'left',
          }
        })
      },300)
    }
  },
};
</script>